import React, { Component } from 'react'

import * as OfficeTypesActions from '../../actions/OfficeTypesActions'

class FilterItem extends Component {
  constructor(props) {
    super(props)

    // Bind events
    this.onFilterChange = this.onFilterChange.bind(this)
  }

  onFilterChange() {
    OfficeTypesActions.toggle(this.props.value)
  }

  render() {
    return (
      <label htmlFor={this.props.value} className="c-location-finder__filter__item">
        <input
          id={this.props.value}
          className="c-location-finder__filter__item__checkbox"
          type="checkbox"
          onChange={this.onFilterChange}
          value={this.props.value}
          checked={this.props.isSelected}
        />
        {this.props.name}{' '}
        <i
          className={`${this.props.icon} c-location-finder__filter__item__icon`}
        />
      </label>
    )
  }
}

export default FilterItem
